import { Link as MuiLink, Stack, Typography } from "@mui/material";
import { type FC } from "react";
import { Link } from "react-router";

import { METHODOLOGY_LINK } from "~/constants/socials";

interface IAppHeadingProps {
  title: string;
  subtitle: string;
  linkTo?: string;
  linkName?: string;
}

export const AppHeading: FC<IAppHeadingProps> = ({
  title,
  subtitle,
  linkTo = METHODOLOGY_LINK,
  linkName = "Read more...",
}) => {
  return (
    <Stack>
      <Typography component="h1" variant="caption" sx={{
        fontWeight: 600
      }}>
        {title}
      </Typography>
      <Typography
        component="h2"
        variant="caption"
        sx={{
          color: "text.secondary",
          maxWidth: 1100
        }}>
        {subtitle}{" "}
        <MuiLink
          component={Link}
          to={linkTo}
          color="inherit"
          sx={{
            typography: "caption",
            fontWeight: 600
          }}>
          {linkName}
        </MuiLink>
      </Typography>
    </Stack>
  );
};
